<app-layout columnCount="12">
  <app-layout-title>
    <app-go-back-button (click)="goBack()">
      {{ 'ADMIN.webhook_test' | translate }}
    </app-go-back-button>
  </app-layout-title>

  <app-layout-content class="grid">
    <div class="input">
      <mat-form-field>
        <textarea matInput cdkTextareaAutosize [(ngModel)]="this.eventExample">
        </textarea>
      </mat-form-field>
      <app-button-group>
        <button (click)="sendTestRequest()" color="primary" mat-raised-button>
          {{ 'ADMIN.send_test_request' | translate }}
        </button>
        <button (click)="resetInputForm()" color="warn" mat-raised-button>
          {{ 'CONTROLS.reset' | translate }}
        </button>
      </app-button-group>
    </div>

    <div class="output-content">
      @if (loadError) {
        <p role="alert">{{ 'ADMIN.request_failed' | translate }}</p>
      }
      @if (loader) {
        <app-loader [isLocal]="true"></app-loader>
      }
      <h3>{{ 'ADMIN.output' | translate }}</h3>
      <pre class="output">{{ this.testResult }}</pre>
    </div>
  </app-layout-content>
</app-layout>
